import { ContactUpdates } from 'components/ContactUpdates/ContactUpdates';
import { FundingRequirements } from 'components/FundingRequirements/FundingRequirements';
import styles from './TalkingToCustomer.module.css';

export const TalkingToCustomer = () => {
  return (
    <div className={styles.container}>
      <FundingRequirements />
      <ContactUpdates />
    </div>
  );
};
